import React, { useEffect, useState } from 'react';

const ViewAndIngestModal = ({
  isOpen,
  onClose,
  item,
  onRejectAndDelete,
  onApproveAndIngest,
}) => {
  const [isRendered, setIsRendered] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [actionState, setActionState] = useState('idle');

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setIsRendered(true), 10);
      setIsClosing(false);
      setActionState('idle');
    } else {
      setIsRendered(false);
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  const handleApprove = async () => {
    setActionState('ingesting');
    try {
      await onApproveAndIngest(item);
      handleClose();
    } catch (error) {
      setActionState('idle'); 
    }
  };

  const handleReject = async () => {
    setActionState('rejecting');
    try {
      await onRejectAndDelete(item);
      handleClose();
    } catch (error) {
      setActionState('idle');
    }
  };

  if (!isOpen && !isRendered && !isClosing) return null;
  const isBusy = actionState !== 'idle';
  const showAnimation = isRendered && !isClosing;

  return (
    <>
      <div 
        className={`fixed inset-0 z-[9998] bg-black/40 backdrop-blur-sm transition-opacity duration-300 ${showAnimation ? "opacity-100" : "opacity-0"}`}
        onClick={!isBusy ? handleClose : undefined} 
      />

      <div 
        className={`fixed inset-y-0 right-0 z-[9999] w-[600px] max-w-[70vw] bg-white shadow-2xl flex flex-col font-outfit transform transition-transform duration-300 ease-in-out ${showAnimation ? "translate-x-0" : "translate-x-full"}`} 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 pt-6 pb-4">
          <h2 className="text-[#BB42AE] text-[22px] font-semibold truncate pr-4">
            {item?.name || "Document"}
          </h2>
          <button onClick={!isBusy ? handleClose : undefined} disabled={isBusy} className={`text-gray-400 transition-colors ${isBusy ? 'opacity-50' : 'hover:text-gray-600'}`}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="flex items-center justify-between px-6 pb-4">
          <h3 className="text-[#333333] font-medium text-[16px]">Summary</h3>
        </div>

        <div className="px-6 pb-6 overflow-y-auto custom-scrollbar flex-1">
          <div className="bg-[#97979712] rounded-xl p-4 text-[#000000B3] text-[15px] leading-relaxed whitespace-pre-wrap font-normal">
            {(item?.meta_summary || "").toLowerCase() === "done"
              ? (item?.summary || <span className="italic text-gray-400">No summary available for this document.</span>)
              : <span className="italic text-gray-400">{item?.meta_summary || "No summary available for this document. It may still be processing."}</span>}
          </div>
        </div>

        <div className="flex items-center justify-end gap-4 px-6 py-4 bg-white mt-auto ">
          <button 
            onClick={handleReject}
            disabled={isBusy}
            className={`px-6 py-2.5 rounded-md border font-semibold transition-all duration-300 text-[14px] w-[160px] flex items-center justify-center gap-2 border-[#D9D9D9] text-[#BB42AE] hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            {actionState === 'rejecting' ? (
              <><div className="w-4 h-4 border-2 border-[#BB42AE] border-t-transparent rounded-full animate-spin"></div>Rejecting...</>
            ) : "Reject & Delete"}
          </button>
          
          <button 
            onClick={handleApprove}
            disabled={isBusy}
            className={`px-6 py-2.5 rounded-md font-semibold transition-all duration-300 text-[14px] w-[180px] flex items-center justify-center gap-2 bg-[#BB42AE] text-white hover:bg-[#A33898] disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            {actionState === 'ingesting' ? (
              <><div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>Ingesting...</>
            ) : "Approve & Ingest"}
          </button>
        </div>
      </div>
    </>
  );
};

export default ViewAndIngestModal;